/* LP v2 wizard — Cart API checkout path + the receipt-step hold timer.
 *
 * window.AflWizCart
 *   addToCart(root, pieces, attrs)    /cart/clear → /cart/update {attributes} → /cart/add {items}
 *                                     (afroyla-preorder-cart.js decorates the add body with the
 *                                     pre-order properties from the registry blobs on the page)
 *   startHold(root, minutes)          starts / resumes the countdown in `[data-wiz-timer]`
 *   releaseForCheckout()              stops the clock — Shopify's checkout owns the cart now
 *   resetHold()                       clears the stored deadline
 *   onExpire(fn)                      the wizard resets itself when the hold ends
 *
 * The hold is theatre (owner 08.09): it starts when the receipt step opens
 * and, when it ends, the wizard goes back to step 1 with an "ended" notice.
 * Nothing is added to the cart until Checkout is tapped, so expiry never has
 * to empty a cart. Attributes always carry `_afl_lp` (the discount gate) and,
 * when ab.js has assigned this visitor, `_ab_visitor` / `_ab_assignments` so
 * orders attribute to the experiment arm even though checkout is reached
 * without ab.js's own cart hook. */
(function () {
  'use strict';

  var KEY_LOCK = 'afl:v2:lock_until';
  var timer = null;
  var expireHandlers = [];

  function store(k, v) {
    try {
      if (v == null) localStorage.removeItem(k);
      else localStorage.setItem(k, String(v));
    } catch (e) {}
  }
  function read(k) {
    try {
      return localStorage.getItem(k);
    } catch (e) {
      return null;
    }
  }

  /* ab.hc.tools attribution (same rule as v1's abAttributes) */
  function abAttributes() {
    try {
      var all = typeof window.aflHcabAssignments === 'function' ? window.aflHcabAssignments() : (window.__HCAB && window.__HCAB.assignments) || {};
      var ids = Object.keys(all || {});
      var m = document.cookie.match(/(?:^|;\s*)_hcab_vid=([^;]+)/);
      if (!ids.length || !m) return {};
      return {
        _ab_visitor: decodeURIComponent(m[1]),
        _ab_assignments: ids.map(function (id) {
          return id + ':' + all[id];
        }).join(','),
      };
    } catch (e) {
      return {};
    }
  }

  function post(path, body) {
    return window.fetch(path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body || {}),
    }).then(function (res) {
      if (!res.ok) {
        var err = new Error(path + ' ' + res.status);
        err.status = res.status;
        throw err;
      }
      return res;
    });
  }

  /* pieces: [{variantId, kind}] → aggregated items (same variant twice = quantity 2) */
  function itemsOf(pieces) {
    var order = [];
    var qty = {};
    pieces.forEach(function (p) {
      if (!p || !p.variantId) return;
      if (qty[p.variantId]) qty[p.variantId] += 1;
      else {
        qty[p.variantId] = 1;
        order.push(p.variantId);
      }
    });
    return order.map(function (id) {
      return { id: id, quantity: qty[id] };
    });
  }

  function addToCart(root, pieces, extraAttrs) {
    var attrs = abAttributes();
    var lpKey = (root.getAttribute('data-lp-key') || '').trim();
    if (lpKey) attrs._afl_lp = lpKey;
    Object.keys(extraAttrs || {}).forEach(function (k) {
      attrs[k] = extraAttrs[k];
    });
    var items = itemsOf(pieces);
    if (!items.length) return Promise.reject(new Error('nothing to add'));
    return post('/cart/clear.js')
      .then(function () {
        return post('/cart/update.js', { attributes: attrs });
      })
      .then(function () {
        return post('/cart/add.js', { items: items });
      });
  }

  /* ---- hold timer -------------------------------------------------------- */
  function pad(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function stopTimer() {
    if (timer) clearInterval(timer);
    timer = null;
  }

  function expire() {
    stopTimer();
    store(KEY_LOCK, null);
    expireHandlers.forEach(function (fn) {
      try {
        fn();
      } catch (e) {}
    });
  }

  /* Checkout tapped: the hold has done its job — stop the clock so nothing
     resets the page while Shopify's checkout owns the cart. */
  function releaseForCheckout() {
    stopTimer();
    store(KEY_LOCK, null);
  }

  function startHold(root, minutes) {
    var out = root.querySelector('[data-wiz-timer]');
    var wrap = root.querySelector('[data-wiz-hold]');
    var until = parseInt(read(KEY_LOCK), 10);
    var now = Date.now();
    if (!until || until < now) {
      until = now + minutes * 60000;
      store(KEY_LOCK, until);
    }
    stopTimer();
    var paint = function () {
      var left = Math.max(0, until - Date.now());
      var s = Math.ceil(left / 1000);
      if (out) out.textContent = pad(Math.floor(s / 60)) + ':' + pad(s % 60);
      if (wrap) wrap.classList.toggle('is-low', s <= 60);
      if (left <= 0) expire();
    };
    paint();
    timer = setInterval(paint, 250);
  }

  function onExpire(fn) {
    expireHandlers.push(fn);
  }

  function resetHold() {
    stopTimer();
    store(KEY_LOCK, null);
  }

  window.AflWizCart = {
    addToCart: addToCart,
    startHold: startHold,
    releaseForCheckout: releaseForCheckout,
    resetHold: resetHold,
    onExpire: onExpire,
  };
})();
